import React, { Component } from 'react'
import { Mutation } from 'react-apollo'
import { gql } from 'apollo-boost'
import { Field, Control, Input, Title, Subtitle, Button } from 'bloomer'
import { Link } from 'react-router-dom'

import { AUTH_TOKEN_KEY } from '../../constants'

const LOGIN = gql`
  mutation Login($username: String!, $password: String!) {
    tokenAuth(username: $username, password: $password) {
      token
    }
  }
`

class SignInForm extends Component {

  state = {
    username: '',
    password: '',
    isLoading: false
  }

  handleChange = (key) => (evt) => {
    const value = evt.target.value
    this.setState(() => ({[key]: value}))
  }

  handleSubmit = async (loginMutation, evt) => {
    evt.preventDefault()

    const { loginHandler } = this.props
    const { username, password } = this.state

    if (username === '' || password === '') {
      return
    }

    this.setState(() => ({ isLoading: true }))
    localStorage.removeItem(AUTH_TOKEN_KEY)
    try {
      const result = await loginMutation({
        variables: {username, password}
      })

      const { token } = result.data.tokenAuth
      localStorage.setItem(AUTH_TOKEN_KEY, token)
      await loginHandler()
    } catch (e) {
      this.setState(() => ({ isLoading: false }))
    }
  }

  render() {
    const { username, password, isLoading } = this.state

    return (
      <Mutation mutation={LOGIN}>
       {(login) => (
        <form onSubmit={this.handleSubmit.bind(this, login)}>
          <Title isSize={3}>Acessar</Title>
          <Subtitle isSize={5}>Entre com sua conta</Subtitle>
          <Field>
            <Control>
              <Input type="text" placeholder="Usuário" autoFocus onChange={this.handleChange('username').bind(this)} value={username} />
            </Control>
          </Field>
          <Field>
            <Control>
              <Input type="password" placeholder="Senha" onChange={this.handleChange('password').bind(this)} value={password} />
            </Control>
          </Field>
          <Field>
            <Button isColor="primary" type="submit" isFullWidth isLoading={isLoading}>Acessar</Button>
          </Field>
          <Button className="is-text">Esqueci a senha</Button>
          <Button className="is-text" render={(props) => <Link to="/register" {...props}>Não tenho conta</Link>} />
        </form>
       )}
      </Mutation>
    )
  }
}

export default SignInForm



// WEBPACK FOOTER //
// ./src/pages/IdentificationPage/SignInForm.js